import React from 'react';
import { CountdownTimer } from './CountdownTimer';
export function UrgencySection() {
  return <section className="w-full bg-[#0A0A0A] py-16 px-4 border-t border-[#16161F]" data-id="element-225">
      <div className="max-w-2xl mx-auto" data-id="element-226">
        <div className="bg-[#16161F] border border-[#00A650] rounded-3xl p-8 sm:p-10 text-center shadow-2xl relative overflow-hidden" data-id="element-227">
          <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-[#00A650] to-[#22C55E]" data-id="element-228" />

          <p className="text-[#00A650] text-xs sm:text-sm font-black uppercase tracking-widest mb-4" data-id="element-229">
            ⏰ Oferta por tiempo limitado
          </p>

          <h2 className="text-2xl sm:text-4xl font-black text-white mb-8 tracking-tight" data-id="element-230">
            El precio de lanzamiento termina en:
          </h2>

          <div className="mb-8" data-id="element-231">
            <CountdownTimer size="lg" blinking={true} data-id="element-232" />
          </div>

          <p className="text-white text-base sm:text-lg font-bold mb-8" data-id="element-233">
            Después, el precio sube <span className="text-[#00A650]" data-id="element-234">$5</span> y
            no vuelve atrás.
          </p>

          <div className="max-w-sm mx-auto" data-id="element-235">
            <div className="w-full bg-[#0A0A0A] rounded-full h-4 overflow-hidden border border-[#00A65033] mb-3" data-id="element-236">
              <div className="h-full rounded-full bg-gradient-to-r from-[#00A650] to-[#22C55E]" style={{
              width: '72%'
            }} data-id="element-237" />
            </div>
            <div className="flex items-center justify-between px-1" data-id="element-238">
              <span className="text-[#00A650] font-black text-xs uppercase tracking-wider" data-id="element-239">
                🔴 Cupos limitados
              </span>
              <span className="text-[#B0B0C0] font-bold text-xs uppercase tracking-wider" data-id="element-240">
                72% reservados
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}